import { ReactElement, ReactNode } from "react";

export interface ConfigurationMenuItem {
  title: string;
  icon?: ReactNode;
  path: string;
  pathFilter?: (path: string) => boolean;
  element?: ReactElement;
  children?: ConfigurationMenuItem[];
}

export type MenuSelectionPath = [string, string, string] | [string, string] | [string] | [];
export type MenuSelection = {
  root?: ConfigurationMenuItem;
  levelOne?: ConfigurationMenuItem;
  levelTwo?: ConfigurationMenuItem;
};

export function firstPartOfPath(routePath: string): string {
  return routePath.split("/")[1];
}

export function transformRouteToSelectionPath(routePath: string): MenuSelectionPath {
  // @ts-ignore
  return routePath
    .split("/")
    .filter((s) => s.length > 0)
    .slice(1, 4);
}

export function findConfigurationMenuItem(
  routePath: string,
  items: ConfigurationMenuItem[]
): MenuSelection {
  const path = transformRouteToSelectionPath(routePath);
  const root = path.length > 0 ? findMenuItem(path[0]!, items) : undefined;
  const levelOne =
    root?.children && path.length > 1 ? findMenuItem(path[1]!, root.children) : undefined;
  const levelTwo =
    levelOne?.children && path.length > 2 ? findMenuItem(path[2]!, levelOne.children) : undefined;
  return { root, levelOne, levelTwo };
}

export function hasChildItems(item?: ConfigurationMenuItem) {
  return item && item.children && item.children.length > 0;
}

function findMenuItem(key: string, items: ConfigurationMenuItem[]) {
  return items.find((item) => item.path === key || item.path.startsWith(":"));
}
